export const css = {
    root: 'Y0dsO3R5',
    bio: 'FSmztsv6',
    ' _key': 'class-roster/biography'
};
export default css;
